/** @file The repo's only base64 encoder (RFC 4648, padded, R2-12), no btoa or Buffer; api imports it. */

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

/** Encodes bytes as padded base64 text. */
export function bytesToBase64(bytes: Uint8Array): string {
  const parts: string[] = [];
  for (let i = 0; i < bytes.length; i += 3) {
    const rest = bytes.length - i;
    const n = ((bytes[i] ?? 0) << 16) | ((bytes[i + 1] ?? 0) << 8) | (bytes[i + 2] ?? 0);
    parts.push(
      ALPHABET.charAt((n >> 18) & 63),
      ALPHABET.charAt((n >> 12) & 63),
      rest > 1 ? ALPHABET.charAt((n >> 6) & 63) : '=',
      rest > 2 ? ALPHABET.charAt(n & 63) : '=',
    );
  }
  return parts.join('');
}
